// extracted by mini-css-extract-plugin
export var component = "Loading-module--component--XlUnv";
export var fullscreen = "Loading-module--fullscreen--6n8IY";
export var spinner = "Loading-module--spinner--EhTxc";